import React from "react";
import { Button, Flex, Heading, Modal, Text, TextButton } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedCardRemovalModal = function SavedCardRemovalModal(_ref) {
  var isOpen = _ref.isOpen,
      heading = _ref.heading,
      prompt = _ref.prompt,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;
  return ___EmotionJSX(Modal, {
    sizeVariant: "medium",
    enableDefaultResponsiveStyles: false,
    isOpen: isOpen,
    onClose: onClose,
    onRequestClose: onClose
  }, ___EmotionJSX(Heading.h3, {
    mt: 0
  }, heading), ___EmotionJSX(Text, null, prompt), ___EmotionJSX(Flex, {
    flexDirection: {
      xs: "column",
      md: "row"
    },
    mt: 8
  }, ___EmotionJSX(Button, {
    onClick: onConfirm,
    mr: {
      xs: 0,
      md: 12
    },
    mb: {
      xs: 4,
      md: 0
    }
  }, "Confirm"), ___EmotionJSX(TextButton, {
    onClick: onClose,
    fontSize: "base"
  }, "Cancel")));
};
export default SavedCardRemovalModal;